var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"production-generator"},[_c('canvas',{ref:"canvas",attrs:{"id":"canvas","height":_vm.canvasResolution,"width":_vm.canvasResolution}})])
}
var staticRenderFns = []

export { render, staticRenderFns }